import React from 'react';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { TIPO_USUARIO as tipoUsuario } from '../../../../consts/tipoUsuario';

export default function SeccionPreviewCliente({ clientesSeleccionados, idTipoUsuario }) {

    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
            sx={{
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),              
                borderRadius: 0,
                fontSize: '0.75rem',
                ...sx,
                padding: 1
            }}
            {...other}
            />
        );
    }
      
    ItemR.propTypes = {       
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    return (
        <>
            {
                (clientesSeleccionados.length > 0) && (idTipoUsuario == tipoUsuario.CLIENTE) &&
                <>
                    <div style={{ fontSize: '10pt', backgroundColor: '#0072BA', color: 'white', width: '100%', textAlign: 'center', padding: 5 }}>
                        Clientes
                    </div>
                    <Grid container spacing={0.5}>
                        {
                            clientesSeleccionados.map( (cliente) => {
 return <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                                            <ItemR>
                                                <strong>{ cliente.cod_Cliente } - { cliente.nom_Com }</strong> (CUIT { cliente.cUIT } - { cliente.domicilio } { cliente.localidad } {cliente.provincia })
                                            </ItemR>
                                        </Grid> 
                            })
                        }              
                    </Grid>
                </>
            }
        </>
    )

};